import { Controller, useFormContext } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import { useId } from 'react'

import { TNewMedAlertFormValues } from './new-med-alert-form.component'
import { EMedAlertUi, MED_ALERT_UI_TO_TAG_STATUS } from 'src/types/med-alert'
import { CurecallTag } from '@honestica/curecall-ui'

export function MedAlertColorRadio() {
  const { t } = useTranslation()
  const fieldsetId = useId()
  const { control } = useFormContext<TNewMedAlertFormValues>()

  const colors = [
    {
      value: EMedAlertUi.DANGER,
      label: t('pages.configuration.followups.chatbot.med-alert-modal.color-danger'),
    },
    {
      value: EMedAlertUi.WARNING,
      label: t('pages.configuration.followups.chatbot.med-alert-modal.color-warning'),
    },
    {
      value: EMedAlertUi.SUCCESS,
      label: t('pages.configuration.followups.chatbot.med-alert-modal.color-success'),
    },
  ]

  return (
    <Controller
      control={control}
      name="ui"
      rules={{ required: true }}
      render={({ field }) => (
        <fieldset className="c-flex c-flex-col">
          <legend className="c-text-base c-font-light c-text-gray-700 c-mb-2">
            {t('pages.configuration.followups.chatbot.med-alert-modal.med-alert-color')}
            <span className="c-text-red-500 c-ml-1" aria-label="requis">
              *
            </span>
          </legend>

          <div className="c-flex c-gap-6" role="group">
            {colors.map((color) => {
              const inputId = `${fieldsetId}-${color.value}`

              return (
                <div key={color.value} className="c-flex c-items-center">
                  <input
                    type="radio"
                    id={inputId}
                    name={field.name}
                    value={color.value}
                    checked={field.value === color.value}
                    onChange={() => field.onChange(color.value)}
                    onBlur={field.onBlur}
                    className="c-w-4 c-h-4 c-text-primary focus:c-ring-primary c-cursor-pointer"
                  />
                  <label htmlFor={inputId} className="c-ml-1.5 c-cursor-pointer">
                    <CurecallTag
                      status={MED_ALERT_UI_TO_TAG_STATUS[color.value]}
                      className="tw-cursor-pointer"
                    >
                      {color.label}
                    </CurecallTag>
                  </label>
                </div>
              )
            })}
          </div>
        </fieldset>
      )}
    />
  )
}
